/**
 * Zeus PDP — select assigned variant media after carousel initialization.
 * Impact initializes non-first slides before its scroll area is available.
 * On desktop grids the carousel cannot scroll, so the variant class also
 * promotes the assigned image through the existing CSS order and span.
 */
(function () {
  var CLASS = "product-gallery__media--variant-main";

  function syncGallery(form, variant, initial) {
    if (!form) return;

    // Shopify forms contain an input named "id", which shadows form.id.
    var formId = form.getAttribute("id");
    if (!formId) return;

    var gallery = document.querySelector('product-gallery[form="' + formId + '"]');
    if (!gallery) return;

    var items = gallery.querySelectorAll(".product-gallery__media");
    items.forEach(function (el) {
      el.classList.remove(CLASS);
    });

    var mediaId = variant && variant.featured_media && variant.featured_media.id;
    var target = mediaId && gallery.querySelector('.product-gallery__media[data-media-id="' + mediaId + '"]');
    if (!target || target.hasAttribute("hidden")) {
      target = Array.prototype.find.call(items, function (item) {
        return !item.hasAttribute("hidden");
      });
    }
    if (!target) return;

    // Impact initializes its non-first slide before its scroll area exists.
    // Force selection after upgrade, even when selectedIndex already matches.
    gallery.querySelectorAll("media-carousel").forEach(function (carousel) {
      var index = Array.prototype.indexOf.call(carousel.items || [], target);
      if (index >= 0 && typeof carousel.select === "function") {
        carousel.select(index, { animate: false, force: true });
      }
    });

    target.classList.add(CLASS);

    if (!initial && window.matchMedia("(min-width: 1000px)").matches) {
      var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      target.scrollIntoView({
        block: "nearest",
        inline: "nearest",
        behavior: reduceMotion ? "auto" : "smooth",
      });
    }
  }

  function bindForm(form) {
    if (!form || form.dataset.zeusGalleryVariantBound === "1") return;
    form.dataset.zeusGalleryVariantBound = "1";
    form.addEventListener("variant:change", function (event) {
      syncGallery(form, event.detail && event.detail.variant);
    });
  }

  function galleriesIn(root) {
    if (!root) return [];
    if (typeof root.matches === "function" && root.matches("product-gallery[form]")) {
      return [root];
    }
    if (typeof root.querySelectorAll !== "function") return [];
    return Array.prototype.slice.call(root.querySelectorAll("product-gallery[form]"));
  }

  function init(root) {
    galleriesIn(root || document).forEach(function (gallery) {
      var formId = gallery.getAttribute("form");
      var form = document.forms[formId];
      bindForm(form);

      var picker = document.querySelector('variant-picker[form-id="' + formId + '"]');
      var script = picker && picker.querySelector("script[data-variant]");
      if (!script) return;

      try {
        var variant = JSON.parse(script.textContent || "null");
        customElements.whenDefined("media-carousel").then(function () {
          requestAnimationFrame(function () {
            syncGallery(form, variant, true);
          });
        });
      } catch (err) {
        /* ignore malformed variant JSON */
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }
  document.addEventListener("shopify:section:load", function (event) {
    if (!event || !event.target) return;
    init(event.target);
  });
})();
